window.addEventListener('DOMContentLoaded', function() {
    const mapLocator = (() => {
        /**************************/
        /***** VARS / CONSTS ******/
        /**************************/
        let _points = []; let _markers = {};
        let mapEnabled = false;
        const $map = document.getElementById("map");
        const $container = document.getElementById("locator");
        const $searchContainer = document.getElementById("search-map");
        const $addressInput = document.getElementById("address-input");
        const $citycodeInput = document.getElementById("citycode-input");
        const $serviceInput = document.getElementById("service-input");
        const $searchForm = document.getElementById("search-form");
        const $searchTotal = document.getElementById("search-total");
        //const $searchResults = document.getElementById("search-results");
        const $searchCollection = document.getElementById("search-collection");
        const $searchNopoint = document.getElementById("search-nopoint");
        const $searchReset = document.getElementById("search-reset");
        const $searchSubmit = document.getElementById("search-submit");

        let map = null;
        let markerClusterer = null;
        let icon = null; let iconHome;
        let infowindow = null;

        /**********************/
        /******* INIT *******/
        /**********************/
        async function init() {            
            /**********************/
            /******* EVENTS *******/
            /**********************/
            $searchForm.addEventListener("submit", (e) => {
                e.preventDefault();
                submitSearch($serviceInput.value);
            });
            // localise item
            $searchCollection.addEventListener("click", (e) => {
                const target = e.target.closest("[data-focus-marker]");
                if(target){
                    e.preventDefault();
                    var marker = _markers[target.dataset.focusMarker];
                    map.panTo(marker.position);
                    map.setZoom(12);
                    new google.maps.event.trigger( marker, 'click' );

                    //MOBILE CLOSE SEARCH RESULTS
                    if(window.matchMedia("(max-width: 1280px)").matches) {
                        $searchContainer.classList.add('hide');
                    }
                }
            });
            // reset search form
            $searchReset.addEventListener("click", (e) => {
                e.preventDefault();
                toggleLoading($container, true);
                _theAddress = null;
                $addressInput.value = "";
                $serviceInput.value = "";
                $serviceInput.parentElement.classList.toggle('disabled', true);
                $searchSubmit.toggleAttribute("disabled", true);
                if(mapEnabled)
                    markerClusterer.clearMarkers();
                $searchCollection.innerHTML = "";
                $searchTotal.innerHTML = 0;
                toggleLoading($container, false);
            });
            async function submitSearch(service){
                toggleLoading($container, true);
                if(_theAddress == null){
                    _theAddress = await getAddressDetail($addressInput.value);
                }
                if(service && _theAddress){
                    refreshPoints(service, $serviceInput.options[$serviceInput.selectedIndex].dataset.type, _theAddress.properties.postcode, _theAddress.properties.citycode);
                }
                else {
                    toggleLoading($container, false);
                }
            }
            async function refreshPoints(service, type, postcode, inseecode) {
                toggleLoading($container, true);                
                $searchCollection.innerHTML = "";                
                fetch(_locator.ajaxurl, {
                    method: 'POST',
                    body: new URLSearchParams({
                        action : 'get_points',
                        service : service,
                        type: type,
                        postcode: postcode,
                        inseecode: inseecode,
                        point: _locator._point
                    }),
                })
                    .then(response => response.json())
                    .then(function(points){          
                        _points = points.data;
                        let pointDistances = {}; 
                        points.data.forEach(function(point, i){
                            let distance = null;
                            if(_theAddress && point.marker.latlng){
                                distance = getDistance([_theAddress.geometry.coordinates[1], _theAddress.geometry.coordinates[0]], point.marker.latlng.split(','));
                            }
                            // --- for sorting item
                            pointDistances[i] = distance;
                        });
                        // items sorted
                        for (const [i, distance] of Object.entries(pointDistances).sort((a, b) => a[1] - b[1])) {
                            let div = document.createElement('div');
                            div.innerHTML = points.data[i].item.trim();
                            if(distance)
                                div.querySelector('.distance').innerHTML = distance.toFixed(1);
                            else
                                div.querySelector('.distance').parentElement.remove();
                            $searchCollection.appendChild(div.firstChild);
                        }
                        //SEARCH RESULTS DISPLAY
                        if ($searchContainer.classList.contains('hide')) {
                            $searchContainer.classList.remove('hide');
                        }
                        // nb results
                        $searchTotal.innerHTML = points.data.length;
                        $searchNopoint.classList.toggle('hidden', (points.data.length > 0));                       
                        slideItemMapResult();
                        if(mapEnabled)
                            pointsToMarkers();
                        toggleLoading($container, false);
                    });
            }
            if(_locator._point != null){
                await refreshPoints(null, null, null, null, _locator._point);                
            }
            else if($addressInput.value && $serviceInput.value){
                submitSearch($serviceInput.value);
            }
            else {
                await refreshPoints();
            }
        }
        /***********************/
        /****** FUNCTIONS ******/
        /***********************/
        const pointsToMarkers = () => {
            markerClusterer.clearMarkers();
            if(_points.length == 0)
                return;            
            _markers = {}; 
            var bounds = new google.maps.LatLngBounds();   
            let theAdressLatLng = null;                         
            if(_theAddress){
                theAdressLatLng = new google.maps.LatLng(_theAddress.geometry.coordinates[1], _theAddress.geometry.coordinates[0]);
                _markers["home"] = new google.maps.Marker({
                    position: theAdressLatLng,
                    map,
                    icon: iconHome
                });
            }                
            _points.forEach(function(point, i){
                if(point.marker.latlng){
                    var latlnga = point.marker.latlng.split(',');
                    var latlng = new google.maps.LatLng(parseFloat(latlnga[0]), parseFloat(latlnga[1]));
                    var marker = new google.maps.Marker({
                        position: latlng,
                        icon: icon,
                        zIndex: 99
                    });
                    marker.addListener("click", function() {
                        var reg = /{{([^}]+)}}/; var match = null;
                        var _content = _locator.infowindowContent;
                        while ((match = _content.match(reg)) != null) {
                            var replace = typeof point.marker[match[1]] != 'undefined' ? point.marker[match[1]] : '';
                            _content = _content.replace(reg, replace);
                        }
                        infowindow.setContent(_content);
                        infowindow.open({
                            anchor: marker,
                            map
                        });
                    });
                    _markers[point.marker.id] = marker;
                    bounds.extend(marker.getPosition());
                }
            });            
            let countMarkers = Object.keys(_markers).length;
            if(countMarkers > 0){
                if(countMarkers == 1){
                    var marker = _markers[Object.keys(_markers)[0]];
                    map.panTo(marker.position);
                    map.setZoom(12);
                    new google.maps.event.trigger( marker, 'click' );
                }
                else {
                    map.fitBounds(bounds);
                    var zoom = map.getZoom();
                    map.setZoom(zoom > 10 ? 10 : zoom);
                }
            }
            else if(_theAddress) {
                map.panTo(theAdressLatLng);
            }
             // cluster
            markerClusterer.addMarkers(_markers);
        }   
        const toggleLoading = ($element, toggle) => {
            sleep(500);
            $element.classList.toggle('loading', toggle);
        }
        async function getAddressDetail(address){
            if(address.length >= 3){
                const response = await fetch('https://api-adresse.data.gouv.fr/search/?q='+address);
                const data = await response.json();
                if (Object.keys(data.features).length > 0) {
                    return data.features[0];
                }
            }
            return null;
        }        
        return {
            init,
            initMap: function (){
                // map
                map = new google.maps.Map($map, {
                    center: new google.maps.LatLng(47.70169003653376, 3.753781586410536),
                    zoom: 7,
                    mapTypeControl: false,
                    fullscreenControl: false,
                    styles: [
                        {
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#000000",
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f9f5ed"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "stylers": [
                                {
                                    "color": "#aee0f4"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative.province",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#c0c0c0"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#c0c0c0"
                                }
                            ]
                        }
                    ]
                });
                icon = {
                    url: _locator.pin.path,
                    anchor: new google.maps.Point(_locator.pin.width / 2, _locator.pin.height)
                };
                iconHome = {
                    url: _locator.pin_home.path,
                    anchor: new google.maps.Point(_locator.pin.width / 2, _locator.pin.height)
                };
                infowindow = new google.maps.InfoWindow({
                    content: ""
                });
                markerClusterer = new MarkerClusterer(map, [], {
                    maxZoom: 9,
                    gridSize: 50,
                    styles: [
                        {
                            width: 40,
                            height: 40,
                        },
                        {
                            width: 40,
                            height: 40,
                        },
                        {
                            width: 40,
                            height: 40,
                        },
                    ],
                    clusterClass: "cluster-locator",
                });
                // areas
                _locator.areas.forEach(function(area){
                    const poly = new google.maps.Polygon({
                        paths: area,
                        strokeColor: "#89C45F",
                        fillColor: "#89C45F",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillOpacity: 0.4
                    });
                    poly.setMap(map);
                });
                mapEnabled = true;
                pointsToMarkers();
            }
        }
    });
    const mapLocatorInstance = mapLocator();
    mapLocatorInstance.init();
    this.window.mapLocator = mapLocatorInstance; // for tarteaucitron

    slideItemMapResult = function(){
        document.querySelectorAll('.search-map-result').forEach(function($result, i){            
            const services = $result.querySelector('.services');
            const seeAll = $result.querySelector('.see-all');
            if(services && seeAll && services.offsetHeight > 60){
                services.style.height = '60px';                 
                seeAll.classList.remove('hidden');
                seeAll.classList.add('flex');
            }
            if(seeAll){
                seeAll.addEventListener("click", function($element){
                    console.log($element);
                    seeAll.classList.add('hidden');
                    services.style.height = 'auto';  
                });
            }
        });
    }
    function rad(x) {
        return x * Math.PI / 180;
    }
    function getDistance(p1, p2) {  
        var lat1 = parseFloat(p1[0]); var lon1 = parseFloat(p1[1]);
        var lat2 = parseFloat(p2[0]); var lon2 = parseFloat(p2[1]);
        var R = 6371; // km
        var dLat = toRad(lat2-lat1);
        var dLon = toRad(lon2-lon1);
        var lat1 = toRad(lat1);
        var lat2 = toRad(lat2);

        var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
        var d = R * c;
        return d;
    }
    function toRad(Value) 
    {
        return Value * Math.PI / 180;
    }
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
});